import { HttpClient } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';
import { Configuration } from './configuration';

import { LogControllerService } from './api/logController.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [LogControllerService]
})
export class AuditApiModule {
  public static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<AuditApiModule> {
    return {
      ngModule: AuditApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }]
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: AuditApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
